namespace MWY {

    export interface IValidateRequired {
        get_required(): boolean;
        set_required(value: boolean): void;
    }

    @Decorators.registerInterface('MWY.IValidateRequired')
    export class IValidateRequired {
    }
}